import { cn } from 'src/shared/components/ui/utils'

/** Compact qty control — used beside the price stack (not a table column). */
export const ProductRowQuantityControl = ({
  isReadOnly,
  isEditMode,
  quantity,
  onQuantityChange,
  className,
}: {
  isReadOnly: boolean
  isEditMode: boolean
  quantity: number
  onQuantityChange: (value: number) => void
  className?: string
}) => {
  if (!isReadOnly || isEditMode) {
    return (
      <input
        type="number"
        value={quantity}
        onChange={(e) => onQuantityChange(Number(e.target.value) || 1)}
        className={cn(
          'input-style h-7 w-14 shrink-0 px-1 text-center text-sm tabular-nums',
          className
        )}
      />
    )
  }

  return (
    <span className={cn('w-14 shrink-0 text-center text-sm tabular-nums', className)}>
      {quantity}
    </span>
  )
}
